import { Record } from 'immutable';
import { DISMISSED_AT, VIEWED_COUNT } from '../constants/userPromptDataKeyPaths';
const UserPromptData = Record({
  [DISMISSED_AT]: 0,
  [VIEWED_COUNT]: 0
}, 'UserPromptData');
export default UserPromptData;